// // // //

import { ClipboardListIcon } from "lucide-react";

/**
 * Empty state component for when no transactions are found
 */
export function TopTransfersEmptyState({ rangeLabel }: { rangeLabel: string }) {
    return (
        <div
            className="flex flex-col items-center justify-center py-12 px-6 text-center"
            style={{ height: "369px" }}
        >
            <div className="mb-4 rounded-full bg-primary-light size-12 flex items-center justify-center">
                <ClipboardListIcon className="size-6 text-primary" />
            </div>
            <h3 className="text-lg font-medium text-foreground mb-2">
                No transactions found
            </h3>
            <p className="text-secondary-foreground max-w-sm">
                No transactions in the {rangeLabel} range for this timeframe.
            </p>
        </div>
    );
}
